import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/data/site";

export default function PrivacyPolicy() {
    return (
        <main data-testid="privacy-page" className="bg-tl-light pb-24 pt-36">
            <div className="mx-auto max-w-3xl px-4 sm:px-6">
                <Link
                    to="/"
                    data-testid="privacy-back-link"
                    className="inline-flex items-center gap-2 font-mono-tl text-xs uppercase tracking-[0.2em] text-tl-mutedDark transition-colors hover:text-tl-orange"
                >
                    <ArrowLeft size={14} /> Torna alla home
                </Link>
                <h1 className="mt-8 font-display text-3xl font-bold tracking-tight text-tl-ink sm:text-4xl">
                    Privacy Policy
                </h1>
                <div className="mt-8 space-y-6 text-sm leading-relaxed text-tl-mutedDark sm:text-base">
                    <p>
                        <strong className="text-tl-ink">Titolare del trattamento:</strong>{" "}
                        {SITE.name}, {SITE.address} — {SITE.vat} — Email: {SITE.email} — Tel:{" "}
                        {SITE.phoneDisplay}.
                    </p>
                    <p>
                        I dati personali inviati tramite il modulo contatti (nome, azienda,
                        email, telefono e contenuto del messaggio) vengono utilizzati
                        esclusivamente per rispondere alla richiesta di informazioni o di
                        preventivo e non vengono ceduti a terzi né utilizzati per finalità
                        di marketing senza consenso.
                    </p>
                    <p>
                        La base giuridica del trattamento è l'esecuzione di misure
                        precontrattuali adottate su richiesta dell'interessato (art. 6,
                        par. 1, lett. b GDPR). I dati sono conservati per il tempo
                        necessario a gestire la richiesta.
                    </p>
                    <p>
                        In qualità di interessato puoi esercitare in qualsiasi momento i
                        diritti previsti dagli artt. 15-22 del GDPR (accesso, rettifica,
                        cancellazione, limitazione, opposizione) scrivendo a {SITE.email}.
                    </p>
                    <p className="rounded-none border border-tl-ink/15 bg-white p-4 font-mono-tl text-xs uppercase tracking-[0.1em] text-tl-mutedDark">
                        Nota: testo da completare e verificare con il proprio consulente
                        privacy prima della pubblicazione definitiva.
                    </p>
                </div>
            </div>
        </main>
    );
}
